import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  HeaderComponent,
  SidebarComponent,
  SanitizeHtmlPipe,
  LogoutModalComponent,
  TermsAndConditionsComponent,
  PrivacyStatementComponent,
  FooterComponent,
  WhoWeAreComponent,
  CustomMatHintComponent,
  TimeStampToDatePipe,
  UtcToLocalPipe,
  SsnFormatDirective,
  PhoneNumberFormatDirective,
  CustomMatSortDirective,
  DowntimeDialogComponent,
  NumberOnlyDirective,
  GlobalLoaderComponent,
} from '@shared';
import { MaterialModule } from '@core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    SanitizeHtmlPipe,
    LogoutModalComponent,
    TermsAndConditionsComponent,
    PrivacyStatementComponent,
    FooterComponent,
    WhoWeAreComponent,
    CustomMatHintComponent,
    TimeStampToDatePipe,
    UtcToLocalPipe,
    SsnFormatDirective,
    PhoneNumberFormatDirective,
    CustomMatSortDirective,
    DowntimeDialogComponent,
    NumberOnlyDirective,
    GlobalLoaderComponent
  ],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
  exports: [
    HeaderComponent,
    SidebarComponent,
    SanitizeHtmlPipe,
    FooterComponent,
    CustomMatHintComponent,
    TimeStampToDatePipe,
    UtcToLocalPipe,
    SsnFormatDirective,
    CustomMatSortDirective,
    PhoneNumberFormatDirective,
    NumberOnlyDirective,
    DowntimeDialogComponent,
    GlobalLoaderComponent
  ],
  providers: [SanitizeHtmlPipe],
})
export class SharedModule {}
